<template>
  <!-- Authors Table Card -->
  <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
    <a-row :gutter="24" type="flex">
      <a-col :span="24" class="mb-24">
        <a-form layout="inline" :form="dataForm" @submit="getDataList" class="ml-20">
          <a-form-item label="人员姓名">
            <a-input v-model="dataForm.name" placeholder="人员姓名" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="addOrUpdateHandle()">新增三要素实名认证</a-button>
          </a-form-item>
        </a-form>

        <a-table :columns="columns" :data-source="dataList" :pagination="false" rowKey="vip_id"
          :loading="dataListLoading" :scroll="{ x: 1400 }">
          <template slot="photo" slot-scope="photo">
            <a-tag>123</a-tag>
          </template>
          <template slot="certificationResult" slot-scope="text">
            <a-tag :color="text == '-1' ? 'blue' : text == '0' ? 'green' : 'red'">{{ text == '-1' ? '审核中' : text == '0'
              ? '审核通过' : '审核被拒' }}</a-tag>
          </template>
        </a-table>
      </a-col>
      <!-- / Authors Table Column -->
    </a-row>

    <a-pagination class="mr-20 float-right" show-size-changer :current="page" :total="total"
      :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange" @change="pageCurrentChangeHandle" />
    <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
  </a-card>
  <!-- / Authors Table Card -->
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/addorupdate.vue";
export default {
  mixins: [viewModule],
  components: {
    addorupdate,
  },
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/admin/yunxin/realNameAuthPage",
      },
      dataForm: {
        name: "",
      },
      columns: [
        {
          title: "认证姓名",
          dataIndex: "name",
          align: 'center',
          width: 200
        },
        {
          title: "认证手机号",
          dataIndex: "phoneNo",
          align: 'center',
          width: 200
        },
        {
          title: "认证人员身份证号",
          dataIndex: "identifyCardNO",
          align: 'center',
          width: 200
        },
        {
          title: "照片",
          dataIndex: "photo",
          scopedSlots: { customRender: "photo" },
          align: 'center',
          width: 200
        },
        {
          title: "认证状态",
          dataIndex: "certificationResult",
          scopedSlots: { customRender: "certificationResult" },
          align: 'center',
          width: 200
        },
        {
          title: "认证失败原因",
          dataIndex: "failureReason",
          align: 'center',
          width: 200
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          align: 'center',
          width: 300
        },
      ],
    };
  },
  methods: {},
};
</script>